import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons"
import { SortDirection } from "@tanstack/react-table"
import { classNames } from "../../../../utils/classNames"
import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"

type Props = {
    sort: Maybe<SortDirection>
}
export const SortArrows = (props: Props) => {
    return (
        <div className={classes.wrap}>
            <CaretUpFill className={classNames(classes.caretTop, props.sort === "asc" && classes.isActive)} />
            <CaretDownFill className={classNames(classes.caretBottom, props.sort === "desc" && classes.isActive)} />
        </div>
    )
}

const classes = {
    wrap: "flex flex-col items-center justify-center",
    caretTop: "w-[9px] h-auto -mb-px text-black/30",
    caretBottom: "w-[9px] h-auto -mt-px text-black/30",
    isActive: "text-primary-color",
}
